import { render, staticRenderFns } from "./cModalTraslate.vue?vue&type=template&id=4d918182"
import script from "./cModalTraslate.vue?vue&type=script&lang=js"
export * from "./cModalTraslate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports